// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__p8DIp","overflowing":"ReadFullNote_overflowing__2ZnFg"};